import { ProductType, PlannerEcsSystem, RangeComponent } from '@inter-ikea-storageone/range';
import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { OutlinedComponent } from '@inter-ikea-core/core';
/**
 * When selecting a leg, all legs in the scene should be selected.
 * Core does not support multi-select, so instead this system will
 * add an outline all legs when one leg is selected.
 */
export class LegSelectionSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'LegSelectionSystem', ComponentIds.SELECTED_COMPONENT_ID);
    }
    onAdd(entity) {
        if (entity.hasComponent(ComponentIds.LEG_COMPONENT_ID)) {
            this.addOutlinesToAllLegs(entity);
        }
    }
    onUpdate() { }
    onRemove(entity) {
        if (entity.hasComponent(ComponentIds.LEG_COMPONENT_ID)) {
            this.removeOutlinesFromAllLegs();
        }
    }
    /**
     * @param entity A leg
     * @returns A support leg that is a sibling to @param entity or null if no support legs on frame
     */
    getSupportLeg(entity) {
        const frame = entity.getComponent(ComponentIds.CHILD_COMPONENT_ID)?.parent;
        if (!frame) {
            return null;
        }
        const supportLegs = HierarchyUtils.children(frame).filter((child) => this.coreApi.entities.getProductType(child) === ProductType.BESTA_SUPPORTING_LEG);
        if (supportLegs.length === 0) {
            return null;
        }
        return supportLegs[0];
    }
    addOutlines(entities) {
        entities.forEach(entity => {
            entity.addComponent(new OutlinedComponent());
        });
    }
    removeOutlines(entities) {
        entities.forEach(entity => {
            entity.removeComponent(ComponentIds.OUTLINED_COMPONENT_ID);
        });
    }
    addOutlinesToAllLegs(selectedLeg) {
        const selectedLegRange = selectedLeg.getComponent(RangeComponent.id)?.range;
        const legs = this.coreApi.entities.getByComponent(ComponentIds.LEG_COMPONENT_ID, selectedLegRange);
        this.addOutlines(legs);
    }
    removeOutlinesFromAllLegs() {
        const legs = this.coreApi.entities.getByComponent(ComponentIds.LEG_COMPONENT_ID);
        this.removeOutlines(legs);
    }
}
//# sourceMappingURL=LegSelectionSystem.js.map